export default (data, activeLang = 'hr') => {
    let filteredArray = []
    if (data && data.length > 0) {
        filteredArray = data.map(val => val[`namjena_${activeLang}`]).filter((val, key, self) => self.indexOf(val) === key)
    }

    return {
        type: 'SET_ALL_REFERENCES_FILTERS',
        payload: filteredArray
    }
}



// WEBPACK FOOTER //
// ./src/scripts/actions/setAllReferencesFilters.js